// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Avatar,
//   InputAdornment,
//   IconButton,
//   FormHelperText,
// } from "@mui/material";
// import { styled } from "@mui/system";
// import { Formik } from "formik";
// import * as Yup from "yup";
// import EmailIcon from "@mui/icons-material/Email";
// import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import { useDispatch } from "react-redux";
// import { createSupportTicketAction } from "../../redux/actions/support/supportActions";
// import { Link } from "react-router-dom";

// /* ------------------------------ Styled Wrapper ------------------------------ */

// const StyledWrapper = styled(Box)(({ theme }) => ({
//   maxWidth: 400,
//   minHeight: 520,
//   margin: "80px auto",
//   padding: "40px 30px 30px 30px",
//   backgroundColor: "#ecf0f3",
//   borderRadius: 15,
//   boxShadow: "13px 13px 20px #cbced1, -13px -13px 20px #fff",
//   [theme.breakpoints.down("sm")]: {
//     margin: "30px 20px",
//     padding: "40px 15px 15px 15px",
//   },
// }));

// const StyledLogo = styled(Avatar)({
//   width: 80,
//   height: 80,
//   margin: "0 auto",
//   boxShadow:
//     "0px 0px 3px #5f5f5f, 0px 0px 0px 5px #ecf0f3, 8px 8px 15px #a7aaa7, -8px -8px 15px #fff",
// });

// const StyledFormField = styled(Box)({
//   paddingLeft: 10,
//   marginBottom: 20,
//   borderRadius: 20,
//   boxShadow: "inset 8px 8px 8px #cbced1, inset -8px -8px 8px #fff",
// });

// const StyledButton = styled(Button)(({ theme }) => ({
//   width: "100%",
//   height: 40,
//   backgroundColor: theme.palette.primary.main,
//   color: "#fff",
//   borderRadius: 25,
//   boxShadow: "3px 3px 3px #b1b1b1, -3px -3px 3px #fff",
//   letterSpacing: 1.3,
//   "&:hover": {
//     backgroundColor: theme.palette.primary.light,
//   },
// }));

// /* ------------------------------ Captcha Generator ------------------------------ */

// const generateCaptcha = () => {
//   const chars =
//     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//   return Array.from({ length: 6 }, () =>
//     chars.charAt(Math.floor(Math.random() * chars.length))
//   ).join("");
// };

// /* ------------------------------ Support Page ------------------------------ */

// const Support = () => {
//   const dispatch = useDispatch();

//   const [captcha, setCaptcha] = useState(generateCaptcha());
//   const canvasRef = useRef(null);

//   /* Draw Captcha on Canvas */
//   const drawCaptcha = () => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);
//     ctx.fillStyle = "#f0f0f0";
//     ctx.fillRect(0, 0, canvas.width, canvas.height);
//     ctx.font = "28px Arial";
//     ctx.fillStyle = "#2679ED";
//     ctx.fillText(captcha, 10, 30);

//     for (let i = 0; i < 5; i++) {
//       ctx.strokeStyle = "#ccc";
//       ctx.beginPath();
//       ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
//       ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
//       ctx.stroke();
//     }
//   };

//   useEffect(() => {
//     drawCaptcha();
//   }, [captcha]);

//   const refreshCaptcha = () => setCaptcha(generateCaptcha());

//   /* ------------------------------ Validation Schema ------------------------------ */

//   const supportSchema = Yup.object().shape({
//     email: Yup.string().email("Invalid email").required("Email is required"),
//     ticketDescription: Yup.string()
//       .min(10, "Must be at least 10 characters")
//       .required("Ticket description is required"),
//     captcha: Yup.string()
//       .required("Captcha is required")
//       .test("match", "Captcha is incorrect", (value) => value === captcha),
//   });

//   /* ------------------------------ Render UI ------------------------------ */

//   return (
//     <Box sx={{ minHeight: "100vh", backgroundColor: "#ecf0f3", p: 1 }}>
//       <StyledWrapper>
//         <StyledLogo
//           alt="Logo"
//           src={require("../../assets/images/logo/Logo.png")}
//         />

//         <Typography
//           variant="h4"
//           align="center"
//           mt={2}
//           sx={{
//             fontWeight: 600,
//             letterSpacing: 1.3,
//             color: "rgb(102, 16, 242)",
//             fontFamily: "'Varela Round', sans-serif",
//           }}
//         >
//           CaseNect Support
//         </Typography>

//         <Formik
//           initialValues={{
//             email: "",
//             ticketDescription: "",
//             captcha: "",
//           }}
//           validationSchema={supportSchema}
//           onSubmit={async (values, { setSubmitting, resetForm }) => {
//             try {
//               await dispatch(createSupportTicketAction(values));
//               resetForm();
//               refreshCaptcha();
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ touched, errors, handleSubmit, getFieldProps, isSubmitting }) => (
//             <form onSubmit={handleSubmit}>
//               <Box sx={{ p: 3, mt: 2 }}>
//                 <StyledFormField>
//                   <TextField
//                     fullWidth
//                     placeholder="Email"
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <EmailIcon sx={{ color: "#555" }} />
//                         </InputAdornment>
//                       ),
//                       disableUnderline: true,
//                       sx: {
//                         fontSize: "1.2rem",
//                         color: "#666",
//                         p: "10px 15px 10px 10px",
//                       },
//                     }}
//                     variant="standard"
//                     {...getFieldProps("email")}
//                     error={Boolean(touched.email && errors.email)}
//                   />
//                 </StyledFormField>
//                 {touched.email && errors.email && (
//                   <FormHelperText error>{errors.email}</FormHelperText>
//                 )}

//                 <StyledFormField>
//                   <TextField
//                     fullWidth
//                     multiline
//                     rows={4}
//                     placeholder="Describe your issue..."
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <MarkChatUnreadIcon sx={{ color: "#555" }} />
//                         </InputAdornment>
//                       ),
//                       disableUnderline: true,
//                       sx: {
//                         fontSize: "1.15rem",
//                         color: "#666",
//                         p: "12px 15px 12px 10px",
//                       },
//                     }}
//                     variant="standard"
//                     {...getFieldProps("ticketDescription")}
//                     error={Boolean(
//                       touched.ticketDescription && errors.ticketDescription
//                     )}
//                   />
//                 </StyledFormField>
//                 {touched.ticketDescription && errors.ticketDescription && (
//                   <FormHelperText error>
//                     {errors.ticketDescription}
//                   </FormHelperText>
//                 )}

//                 <StyledFormField>
//                   <TextField
//                     fullWidth
//                     placeholder="Enter Captcha"
//                     variant="standard"
//                     {...getFieldProps("captcha")}
//                     InputProps={{
//                       disableUnderline: true,
//                       sx: {
//                         fontSize: "1.2rem",
//                         color: "#666",
//                         p: "10px 15px 10px 10px",
//                       },
//                     }}
//                     error={Boolean(touched.captcha && errors.captcha)}
//                   />
//                 </StyledFormField>

//                 {touched.captcha && errors.captcha && (
//                   <FormHelperText error>{errors.captcha}</FormHelperText>
//                 )}

//                 <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                   <canvas
//                     ref={canvasRef}
//                     width={160}
//                     height={40}
//                     style={{ border: "1px solid #ccc" }}
//                   />
//                   <IconButton onClick={refreshCaptcha}>
//                     <RefreshIcon />
//                   </IconButton>
//                 </Box>

//                 <StyledButton type="submit" disabled={isSubmitting}>
//                   {isSubmitting ? "Submitting..." : "Submit Ticket"}
//                 </StyledButton>
//               </Box>
//             </form>
//           )}
//         </Formik>

//         <Box textAlign="center" sx={{ fontSize: "0.8rem", mt: 2 }}>
//           <Link to="/" style={{ textDecoration: "none", color: "#1976d2" }}>
//             Back to Login
//           </Link>
//         </Box>
//       </StyledWrapper>
//     </Box>
//   );
// };

// export default Support;

import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  InputAdornment,
  IconButton,
  FormHelperText,
  AppBar,
  Toolbar,
  Grid,
} from "@mui/material";
import { styled } from "@mui/system";
import { Formik } from "formik";
import * as Yup from "yup";
import EmailIcon from "@mui/icons-material/Email";
import RefreshIcon from "@mui/icons-material/Refresh";
import LoginIcon from "@mui/icons-material/Login";
import { useDispatch } from "react-redux";
import { createSupportTicketAction } from "../../redux/actions/support/supportActions";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { animateCss } from "../TosterAlert";

/* ------------------------------ Styled Wrapper ------------------------------ */

const StyledWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 400,
  minHeight: 520,
  margin: "80px auto",
  padding: "40px 30px 30px 30px",
  backgroundColor: "#ecf0f3",
  borderRadius: 15,
  boxShadow: "13px 13px 20px #cbced1, -13px -13px 20px #fff",
  [theme.breakpoints.down("sm")]: {
    margin: "30px 20px",
    padding: "40px 15px 15px 15px",
  },
}));

const StyledLogo = styled(Avatar)({
  width: 80,
  height: 80,
  margin: "0 auto",
  boxShadow:
    "0px 0px 3px #5f5f5f, 0px 0px 0px 5px #ecf0f3, 8px 8px 15px #a7aaa7, -8px -8px 15px #fff",
});

const StyledFormField = styled(Box)({
  paddingLeft: 10,
  marginBottom: 20,
  borderRadius: 20,
  boxShadow: "inset 8px 8px 8px #cbced1, inset -8px -8px 8px #fff",
});

const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: 40,
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  borderRadius: 25,
  boxShadow: "3px 3px 3px #b1b1b1, -3px -3px 3px #fff",
  letterSpacing: 1.3,
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
  },
}));

/* ------------------------------ Captcha Generator ------------------------------ */

const generateCaptcha = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return Array.from({ length: 6 }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join("");
};

/* ------------------------------ Support Page ------------------------------ */

const Support = () => {
  const dispatch = useDispatch();
  const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [captcha, setCaptcha] = useState(generateCaptcha());
  const canvasRef = useRef(null);

  const drawCaptcha = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = "28px Arial";
    ctx.fillStyle = "#2679ED";
    ctx.fillText(captcha, 10, 30);

    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = "#ccc";
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }
  };

  useEffect(() => {
    drawCaptcha();
    // eslint-disable-next-line
  }, [captcha]);

  const refreshCaptcha = () => setCaptcha(generateCaptcha());

  /* ------------------------------ Validation Schema ------------------------------ */

  const supportSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    ticketDescription: Yup.string()
      .min(10, "Must be at least 10 characters")
      .required("Ticket description is required"),
    captcha: Yup.string()
      .required("Captcha is required")
      .test("match", "Captcha is incorrect", (value) => value === captcha),
  });

  /* ------------------------------ Render UI ------------------------------ */

  return (
    <Box
      sx={{ backgroundColor: "#ecf0f3", pt: 12, minHeight: "100vh", pb: 10 }}
    >
      {/* ---------------- TOP APP BAR (Exact Login Page UI) ---------------- */}
      <Grid container direction="column">
        <Grid item xs={12} sx={{ ml: 3, my: 3 }}>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar
              position="fixed"
              color="default"
              sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  noWrap
                  component="a"
                  href="#"
                  sx={{
                    mr: 2,
                    display: { sm: "block" },
                    fontWeight: 700,
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  <img
                    src={require("../../assets/images/logo/logo192.png")}
                    alt="CaseNect"
                    height={sm ? "30px" : "40px"}
                    width={sm ? "100px" : "200px"}
                  />
                </Typography>

                <Box
                  sx={{ flexGrow: 1, display: "flex", justifyContent: "end" }}
                >
                  <Button
                    component={Link}
                    variant="text"
                    to="/"
                    sx={{
                      my: 2,
                      fontWeight: 700,
                      fontSize: sm ? "12px" : "18px",
                    }}
                    startIcon={<LoginIcon />}
                  >
                    Login
                  </Button>
                </Box>
              </Toolbar>
            </AppBar>
          </Box>
        </Grid>
      </Grid>

      {/* ---------- Support Form ---------- */}

      <StyledWrapper>
        <StyledLogo
          alt="Logo"
          src={require("../../assets/images/logo/Logo.png")}
        />

        <Typography
          variant="h4"
          align="center"
          mt={2}
          sx={{
            fontWeight: 600,
            letterSpacing: 1.3,
            color: "rgb(102, 16, 242)",
            fontFamily: "'Varela Round', sans-serif",
          }}
        >
          CaseNect Support
        </Typography>

        <Formik
          initialValues={{
            email: "",
            ticketDescription: "",
            captcha: "",
          }}
          validationSchema={supportSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              const res = await dispatch(
                createSupportTicketAction(values)
              ).unwrap();

              if (res.success !== false) {
                animateCss(
                  "success",
                  res.message || "Ticket submitted successfully!"
                );
                resetForm();
                refreshCaptcha();
              }
            } catch (err) {
              animateCss("error", "User Not Found or server error");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ touched, errors, handleSubmit, getFieldProps, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <Box sx={{ p: 3, mt: 2 }}>
                <StyledFormField>
                  <TextField
                    fullWidth
                    placeholder="Email"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon sx={{ color: "#555" }} />
                        </InputAdornment>
                      ),
                      disableUnderline: true,
                      sx: {
                        fontSize: "1.2rem",
                        color: "#666",
                        p: "10px 15px 10px 10px",
                      },
                    }}
                    variant="standard"
                    {...getFieldProps("email")}
                    error={Boolean(touched.email && errors.email)}
                  />
                </StyledFormField>

                {touched.email && errors.email && (
                  <FormHelperText error>{errors.email}</FormHelperText>
                )}

                <StyledFormField>
                  <TextField
                    fullWidth
                    multiline
                    rows={5}
                    placeholder="Describe your issue..."
                    InputProps={{
                      // startAdornment: (
                      //   <InputAdornment position="start">
                      //     <MarkChatUnreadIcon sx={{ color: "#555" }} />
                      //   </InputAdornment>
                      // ),
                      disableUnderline: true,
                      sx: {
                        fontSize: "1.15rem",
                        color: "#666",
                        p: "12px 15px 12px 10px",
                      },
                    }}
                    variant="standard"
                    {...getFieldProps("ticketDescription")}
                    error={Boolean(
                      touched.ticketDescription && errors.ticketDescription
                    )}
                  />
                </StyledFormField>

                {touched.ticketDescription && errors.ticketDescription && (
                  <FormHelperText error>
                    {errors.ticketDescription}
                  </FormHelperText>
                )}

                <StyledFormField>
                  <TextField
                    fullWidth
                    placeholder="Enter Captcha"
                    variant="standard"
                    {...getFieldProps("captcha")}
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        fontSize: "1.2rem",
                        color: "#666",
                        p: "10px 15px 10px 10px",
                      },
                    }}
                    error={Boolean(touched.captcha && errors.captcha)}
                  />
                </StyledFormField>

                {touched.captcha && errors.captcha && (
                  <FormHelperText error>{errors.captcha}</FormHelperText>
                )}

                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <canvas
                    ref={canvasRef}
                    width={160}
                    height={40}
                    style={{ border: "1px solid #ccc" }}
                  />

                  <IconButton onClick={refreshCaptcha}>
                    <RefreshIcon />
                  </IconButton>
                </Box>

                <StyledButton type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit Ticket"}
                </StyledButton>
              </Box>
            </form>
          )}
        </Formik>
      </StyledWrapper>
    </Box>
  );
};

export default Support;
